//@flow
import React from 'react';

import notification from '../../Notification/components/StandardNotification.react';
import Constants from '../../constants';
import NumberUtils from '../../Utils/number';

import type { NotificationProps } from '../../Notification/components/StandardNotification.react';

function StoreCreditNotification(props:NotificationProps){
  if (!props.data) return null;

  return (
    <div>
      <p className="bold black">
        You have ${NumberUtils.toFixed(props.data.storeCredit)} of store credit!
      </p>
      <p className="gray-dark">Available credit is automatically applied to your orders in checkout. Don&apos;t let your credit expire!</p>
    </div>
  );
}

export default notification<{}>(StoreCreditNotification, {
  name: Constants.STORE_CREDIT_NOTIFICATION,
  className: 'store-credit-notification',
});
